import { createSlice } from '@reduxjs/toolkit'

const initialProposalsState = {
  filters: {
    client_name: '',
    client_location: '',
    proposal_id: '',
    workorder_id: '',
    submitted_date: '',
    approved_date: '',
    approved_by: '',
    status: '',
    asc_sort: '',
    desc_sort: ''
  },
  proposals: [],
  summary: [],
  loadingFiles: false
}

/**
 * Create a slice of reducer for proposals
 *
 * @type {Slice<{filters: null}, {setFilters(*): void}, string>}
 */
const proposalsSlice = createSlice({
  name: 'proposals',
  initialState: initialProposalsState,
  reducers: {
    setFilters (state, action) {
      state.filters = action.payload
    },
    setProposals (state, action) {
      state.proposals = action.payload
    },
    setSummary (state, action) {
      state.summary = action.payload
    },
    setLoadingFiles (state, action) {
      state.loadingFiles = action.payload
    }
  }
})

export const proposalsActions = proposalsSlice.actions

export default proposalsSlice.reducer
